module.exports = __webpack_public_path__ + "static/wow-0fdb926fb36493ac326d8298e4d48d2d.jpg";